import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { SplitPipe } from '../../pipes/split.pipe';


@Component({
   selector: 'app-comodidades',
   imports: [CommonModule, MatDialogModule, MatIcon, SplitPipe],
   standalone: true,
   templateUrl: './comodidades.component.html',
   styleUrls: ['./comodidades.component.scss']
})
export class ComodidadesComponent {
   @Input() comodidades: string = '';

}
